<template>
    <!-- Modal -->
    <div class="modal fade" id="remarksModal" tabindex="-1" role="dialog" aria-labelledby="remarksModalTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title font-weight-bold ml-2" id="remarksModalTitle">{{crewEndorse.crew}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="setNull">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-5 text-left">
                            <label for="endorsedRemarks" class="font-weight-bold"><small class="tnkc-danger-text h6">*</small>Remarks :</label>
                            <input readonly type="text" id="countdown2" size="3" value="200" class="ml-3 text-muted border-0"><span class="text-muted">Characters Left</span>
                            <div class="form-group mt-3">
                                <input type="text" id="remarkSubject" class="form-control mb-2" v-model="newRemarks.subject"  placeholder="type subject here..."  maxlength="20" />
                                <textarea class="form-control" id="endorsedRemarks" v-model="newRemarks.remarks" style="height: 300px; resize: none;" rows="3"  @keyup="limiteTextRemarks('endorsedRemarks','countdown2',200)"></textarea>
                            </div>
                            <div class="form-group text-right">
                                <button class="btn btn-sm tnkc-success mr-2" @click="create_remarks">
                                    <font-awesome-icon icon="comment-dots"/>
                                    Save
                                </button>
                                <button class="btn btn-sm tnkc-secondary" @click="cancel">
                                    <font-awesome-icon icon="undo"/>
                                    Clear
                                </button>
                            </div>
                        </div>

                        <div class="col-md-7 border-left w-100 text-left">
                            <div class="form-group row ">
                                <label for="endorsedRemarks" class="font-weight-bold ml-3">Previous Remarks :</label>
                            </div>

                            <div class="form-group" id="remarks-wrapper" style="height: 500px;">
                               <div class="mr-2">
                                   <div class="card mb-3" v-for="(remark,index) in remarks" :key="remark.id">
                                       <div class="card-body">
                                           <div class="card-title custom-label text-dark border-bottom">{{remark.subject ? remark.subject : '---'}}</div>
                                           <div class="card-text">
                                               <p>{{remark.remarks}}</p>
                                           </div>
                                       </div>

                                       <div class="card-footer">
                                           <div class="row">
                                               <div class="col-sm-12">
                                                   <div class="row" style="font-size: 12px;" >
                                                       <div class="col-sm-6">
                                                           <small class="text-muted">Created At : </small> <small class="font-weight-bold">{{remark.created_at | moment("DD MMM YYYY - HH:mm") }}</small>
                                                       </div>
                                                       <div class="col-sm-6 border-left border-dark">
                                                           <small class="text-muted">By : </small><small class="font-weight-bold">{{remark.remark_by}}</small>
                                                       </div>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                   </div>
                               </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn tnkc-secondary" data-dismiss="modal" @click="setNull">Close</button>
<!--                    <button type="button" class="btn btn-primary">Save changes</button>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>

  import {mapGetters, mapActions} from 'vuex';
  import {appMixins} from '../../../mixins/app.mixins';

  export default {
    name: 'remarksModal',
    mixins:[appMixins],
    props: {
      id: Number,
      name: String,
      search : {type: Function},
    },

    methods: {

      ...mapActions(['createRemarks','setNullRemarks','setNullCrewEndorsed','setNullNewRemark']),

      setNull(){
        this.setNullNewRemark();
        this.setNullCrewEndorsed();
      },

      create_remarks(){
        this.newRemarks.crew_reservation_id = this.crewEndorse.id;
        this.createRemarks(this.newRemarks).then((res)=>{
          if(res == true){
            this.search();
            this.successAlert('Save Successfully');
            $('#remarksModal').modal('hide');
          }
        });
      },

      cancel(){
        this.setNullNewRemark();
      }
    },

    computed: {
      ...mapGetters(['newRemarks','remark','remarks','crewEndorse']),
    },

    created() {

    },

    mounted() {
      $(function() {
        $("#remarkSubject").on('keydown', function(event) {
          if (this.selectionStart == 0 && event.keyCode >= 65 && event.keyCode <= 90 && !(event.shiftKey) && !(event.ctrlKey) && !(event.metaKey) && !(event.altKey)) {
            let $t = $(this);
            event.preventDefault();
            let char = String.fromCharCode(event.keyCode);
            $t.val(char + $t.val().slice(this.selectionEnd));
            this.setSelectionRange(1,1);
          }
        });

        $("#endorsedRemarks").on('keydown', function(event) {
          if (this.selectionStart == 0 && event.keyCode >= 65 && event.keyCode <= 90 && !(event.shiftKey) && !(event.ctrlKey) && !(event.metaKey) && !(event.altKey)) {
            let $t = $(this);
            event.preventDefault();
            let char = String.fromCharCode(event.keyCode);
            $t.val(char + $t.val().slice(this.selectionEnd));
            this.setSelectionRange(1,1);
          }
        });
      });
    },

    destroyed() {
      this.setNullRemarks();
    },
  };
</script>

<style scoped>

</style>

<style>
    #remarks-wrapper{
        overflow-y: scroll;
    }
</style>
